module.exports = __webpack_public_path__ + "img/hip-roof@2x.a5b52327.png";